const dotValidator = require('../lang/validator/en-dot.json');

function getBrandConfig(name) {
    const aliases = { arusnavi: 'arus', duotec: 'doutec', edvado: 'dot' };
    const normalized = (name || 'arus').toLowerCase();
    const id = aliases[normalized] || normalized;
    if (!['arus', 'doutec', 'dot'].includes(id)) {
        throw new Error(`Unknown frontend brand: ${name}`);
    }
    const isDot = id === 'dot';
    return {
        id,
        favicon: isDot ? 'dot_favicon.svg' : 'favicon.ico',
        faviconType: isDot ? 'image/svg+xml' : 'image/x-icon',
        showDeviceMonitoring: !isDot,
        showFirmwareDescriptions: !isDot,
        englishValidatorMessages: isDot ? dotValidator.messages : {},
    };
}

const brandConfig = getBrandConfig(process.env.VUE_APP_BRAND || process.env.VUE_APP);

function getEnglishValidatorLocale(locale, profile = brandConfig) {
    return {
        ...locale,
        messages: {...locale.messages, ...profile.englishValidatorMessages},
    };
}

module.exports = {
    getBrandConfig,
    brandConfig,
    getEnglishValidatorLocale,
};
